import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Profile() {
  const { user, setUser } = useAuth();
  const [p, setP] = useState({ name: user.name, phone: user.phone || "" });
  const [pw, setPw] = useState({ old_password: "", new_password: "", confirm: "" });

  const saveProfile = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.put("/me/profile", p);
      setUser(data);
      toast.success("Profil disimpan");
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  const savePw = async (e) => {
    e.preventDefault();
    if (pw.new_password !== pw.confirm) return toast.error("Konfirmasi kata sandi tidak sama");
    try {
      await api.put("/me/password", { old_password: pw.old_password, new_password: pw.new_password });
      setPw({ old_password: "", new_password: "", confirm: "" });
      toast.success("Kata sandi berhasil diubah");
    } catch (err) {
      toast.error(errMsg(err));
    }
  };

  return (
    <div className="mx-auto max-w-4xl px-4 py-12 sm:px-6">
      <p className="text-xs font-bold uppercase tracking-[0.25em] text-amber-600">Profil & Pengaturan</p>
      <h1 className="mt-2 text-3xl font-extrabold text-[#0A192F]">Akun saya</h1>
      <div className="mt-8 grid gap-6 md:grid-cols-2">
        <form onSubmit={saveProfile} className="card-premium space-y-4 p-6" data-testid="profile-form">
          <h2 className="font-bold text-[#0A192F]">Data profil</h2>
          <div><Label>Email</Label><Input value={user.email} disabled /></div>
          <div><Label>Nama</Label><Input required value={p.name} onChange={(e) => setP({ ...p, name: e.target.value })} data-testid="profile-name-input" /></div>
          <div><Label>No. HP</Label><Input value={p.phone} onChange={(e) => setP({ ...p, phone: e.target.value })} data-testid="profile-phone-input" /></div>
          <button className="btn-gold rounded-lg px-5 py-2.5 text-sm" data-testid="profile-save-btn">Simpan Profil</button>
        </form>
        <form onSubmit={savePw} className="card-premium space-y-4 p-6" data-testid="password-form">
          <h2 className="font-bold text-[#0A192F]">Ubah kata sandi</h2>
          <div><Label>Kata sandi lama</Label><Input type="password" required value={pw.old_password} onChange={(e) => setPw({ ...pw, old_password: e.target.value })} data-testid="password-old-input" /></div>
          <div><Label>Kata sandi baru</Label><Input type="password" required minLength={6} value={pw.new_password} onChange={(e) => setPw({ ...pw, new_password: e.target.value })} data-testid="password-new-input" /></div>
          <div><Label>Konfirmasi</Label><Input type="password" required value={pw.confirm} onChange={(e) => setPw({ ...pw, confirm: e.target.value })} data-testid="password-confirm-input" /></div>
          <button className="rounded-lg bg-[#0A192F] px-5 py-2.5 text-sm font-semibold text-white hover:bg-[#112240]" data-testid="password-save-btn">Ubah Kata Sandi</button>
        </form>
      </div>
    </div>
  );
}
